import { getUrlParam } from '@tencent/camp-web-shared';

export { parseUrlSearch, getUrlParam } from '@tencent/camp-web-shared';

/**
 * 判断是手机端还是pc端
 * */
export const isMobile = () =>
  !!/(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone)/i.test(
    window.navigator.userAgent,
  );

export const copyText = (text: string, onSuccess?: () => any, onFail?: () => any) => {
  try {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
      onSuccess?.();
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.width = '0px';
      el.style.left = '0px';
      document.body.append(el);
      el.select();
      document.execCommand('copy');
      el.remove();
      onSuccess?.();
    }
  } catch (error) {
    console.warn(error);
    onFail?.();
  }
};

/**
 * 获取linkdata中的信息
 */
export const getLinkDataInfo = () => {
  try {
    const linkData = atob(getUrlParam('linkData'));
    return JSON.parse(linkData);
  } catch (error) {
    console.warn(error);
    return {};
  }
};

/**
 * 获取linkdata中的信息
 */
export const getLinkDataInfoValue = (key: string) => {
  try {
    const linkData = getLinkDataInfo();
    return linkData?.[key] || '';
  } catch (error) {
    console.warn(error);
    return '';
  }
};

/**
 * 判断用户使用的浏览器平台
 */
export const getSocialMediaPlatform = (ua?) => {
  try {
    const userAgent = ua.toLocaleLowerCase() || navigator.userAgent.toLocaleLowerCase();
    if (/instagram/.test(userAgent)) {
      return 'instagram';
    }
    if (/messenger/.test(userAgent)) {
      return 'messenger';
    }
    if (/fban/.test(userAgent) || /fbav/.test(userAgent)) {
      return 'facebook';
    }
    if (/twitter/.test(userAgent)) {
      return 'twitter';
    }
    return 'other';
  } catch {
    return 'other';
  }
};
